(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/middlewares/debug-middleware.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/middlewares/debug-middleware.js');
"use strict";


const logger = svs.core.log.getLogger('racing.game-engine.debug-middleware');
const debugMiddleware = () => next => (state, action) => {
  logger.debug('State before', state);
  logger.debug('Action', action);
  const newState = next(state, action);
  logger.debug('State after', newState);
  return newState;
};
svs.racing.gameEngine.middlewares.debug = debugMiddleware;

 })(window);